import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import {
  getSidebarStatus,
  getSize,
  setSidebarStatus,
  setLanguage,
  setSize,
  setName,
  setLogo,
  getCurrency,
  removeCurrency,
  removeProduct
} from '@/utils/cookies'
import { getLocale } from '@/lang'
import { getEnterprise, getConst, getConstant } from '@/api/universal'
import store from '@/store'

export enum DeviceType {
  Mobile,
  Desktop
}

export interface IAppState {
  device: DeviceType
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
  }
  language: string
  sitename: string
  sitelogo: string
  size: string
  taskCenter: {
    api_log_count: any
    // eslint-disable-next-line camelcase
    application_count: any
    deposit: any
    // eslint-disable-next-line camelcase
    deposit_review_count: any
    exception: any
    // eslint-disable-next-line camelcase
    exception_count: any
    withdraw: any
    // eslint-disable-next-line camelcase
    withdraw_review_count: any
    // eslint-disable-next-line camelcase
    refund_order_count: any
    // eslint-disable-next-line camelcase
    refund_review_count: any
    refund: any
    // eslint-disable-next-line camelcase
    buy_usdt: any

    // eslint-disable-next-line camelcase
    buy_usdt_task_count: any
    // eslint-disable-next-line camelcase
    ant_withdraw: any
    // eslint-disable-next-line camelcase
    ant_review: any
    ant_register_count: any

    // eslint-disable-next-line camelcase
    manage_count: any
  }
  enterprise: {
    name: string
    // eslint-disable-next-line camelcase
    manage_domain: string
    // eslint-disable-next-line camelcase
    merchant_domain: string
    // eslint-disable-next-line camelcase
    checkout_counter_domain: string
    timezone: string
    // eslint-disable-next-line camelcase
    available_currency: any[]
    // eslint-disable-next-line camelcase
    google_auth_switch: boolean
    // eslint-disable-next-line camelcase
    available_crypto_currency: any[]
    // eslint-disable-next-line camelcase
    ssl_switch: {}
    // eslint-disable-next-line camelcase
    sms_apk: string
    // eslint-disable-next-line camelcase
    bot_google_auth_switch: boolean
    corporation: number
    id: number
    // eslint-disable-next-line camelcase
    cloud_instance: string
    // eslint-disable-next-line camelcase
    corporation_name: string
  }
  currentCurrencyType: string
  orderStatusList: any[] // 订单状态列表
  upstreamStatusList: any[] // 上游订单状态
  orderSourceList: any[] // 订单发源地
  bankCodeList: any[] // 银行代号列表
  constant: any | null // 常量表
  causeList: any | null // 明细类型列表
  baseUrl: any // 后端地址
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public enterprise = {
    name: '',
    manage_domain: '',
    merchant_domain: '',
    checkout_counter_domain: '',
    test_merchant_no: '',
    timezone: '',
    available_currency: [],
    google_auth_switch: true,
    available_crypto_currency: [],
    ssl_switch: {},
    sms_apk: '',
    bot_google_auth_switch: false,
    corporation: 0,
    id: 0,
    cloud_instance: '',
    corporation_name: ''
  }
  public currentCurrencyType = ''
  public taskCenter = {
    application_count: 0,
    api_log_count: 0,
    deposit: {},
    deposit_review_count: 0,
    exception: {},
    exception_count: 0,
    withdraw: {},
    withdraw_review_count: 0,
    refund_order_count: 0,
    refund_review_count: 0,
    refund: {},
    buy_usdt: {},
    buy_usdt_task_count: 0,
    ant_withdraw: 0,
    ant_review: 0,
    ant_register_count: 0,
    manage_count: 0
  }
  public constant: any | null = null
  public orderStatusList: any[] = []
  public upstreamStatusList: any[] = []
  public orderSourceList: any[] = []
  public bankCodeList: any[] = []
  public causeList: any | null = null
  public baseUrl: any = ''
  public sidebar = {
    opened: getSidebarStatus() !== 'closed',
    withoutAnimation: false
  }
  public device = DeviceType.Desktop
  public language = getLocale()
  public size = getSize() || 'samll'
  public sitename = 'Admin System'
  public sitelogo = ''

  @Mutation
  private TOGGLE_SIDEBAR (withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    if (this.sidebar.opened) {
      setSidebarStatus('opened')
    } else {
      setSidebarStatus('closed')
    }
  }

  @Mutation
  private CLOSE_SIDEBAR (withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    setSidebarStatus('closed')
  }

  @Mutation
  private TOGGLE_DEVICE (device: DeviceType) {
    this.device = device
  }

  @Mutation
  private SET_LANGUAGE (language: string) {
    this.language = language
    setLanguage(this.language)
  }

  @Mutation
  private SET_SITENAME (name: string) {
    this.sitename = name
    setName(this.sitename)
  }

  @Mutation
  private SET_SITELOGO (logo: string) {
    this.sitelogo = logo
    setLogo(this.sitelogo)
  }

  @Mutation
  private SET_SIZE (size: string) {
    this.size = size
    setSize(this.size)
  }

  @Mutation
  private SET_ENTERPRISE (enterprise: any) {
    this.enterprise.manage_domain = enterprise.manage_domain
    this.enterprise.merchant_domain = enterprise.merchant_domain
    this.enterprise.checkout_counter_domain = enterprise.checkout_counter_domain
    this.enterprise.name = enterprise.name
    this.enterprise.timezone = enterprise.timezone
    this.enterprise.available_currency = enterprise.available_currency
    this.enterprise.test_merchant_no = enterprise.test_merchant_no
    this.enterprise.ssl_switch = enterprise.ssl_switch
    this.enterprise.google_auth_switch = enterprise.google_auth_switch
    this.enterprise.available_crypto_currency =
      enterprise.available_crypto_currency
    this.enterprise.sms_apk = enterprise.sms_apk
    this.enterprise.bot_google_auth_switch = enterprise.bot_google_auth_switch
    this.enterprise.corporation = enterprise.corporation
    this.enterprise.id = enterprise.id
    this.enterprise.cloud_instance = enterprise.cloud_instance
    this.enterprise.corporation_name = enterprise.corporation_name
  }

  @Mutation
  private SET_ORDER_STATUS_LIST (arr: any[]) {
    this.orderStatusList = arr
  }

  @Mutation
  private SET_ORDER_SOURCE_LIST (arr: any[]) {
    this.orderSourceList = arr
  }

  @Mutation
  private SET_UPSTREAM_STATUS_LIST (arr: any[]) {
    this.upstreamStatusList = arr
  }

  @Mutation
  private SET_BANK_CODE_LIST (arr: any[]) {
    this.bankCodeList = arr
  }

  @Mutation
  private SET_CONSTANT (constant: any | null) {
    this.constant = constant
  }

  @Mutation
  private SET_CAUSELIST (causeList: any | null) {
    this.causeList = causeList
  }

  @Mutation
  private SET_BASEURL (baseUrl: any) {
    this.baseUrl = baseUrl
  }

  @Mutation
  private SET_TASK_CENTER (taskCenter: any) {
    this.taskCenter = { ...taskCenter }
  }

  @Mutation
  private SET_CURRENT_CURRENCY_TYPE (obj: any) {
    this.currentCurrencyType = obj
  }

  @Action
  public SetTaskCenter (taskCenter: any) {
    this.SET_TASK_CENTER(taskCenter)
  }

  @Action
  public SetBaseUrl (baseUrl: any) {
    this.SET_BASEURL(baseUrl)
  }

  @Action
  public async GetCauseList () {
    if (!this.causeList) {
      try {
        await getConst('FUND_CAUSE_CHOICES').then((res: any) => {
          this.SET_CAUSELIST(res.data)
        })
        return this.causeList
      } catch (e) {}
    } else {
      return this.causeList
    }
  }

  @Action
  public async GetConstant () {
    if (!this.constant) {
      try {
        await getConstant().then((res: any) => {
          this.SET_CONSTANT(res)
        })
        return this.constant
      } catch (e) {}
    } else {
      return this.constant
    }
  }

  @Action
  public async GetOrderStatusList () {
    if (this.orderStatusList.length === 0) {
      try {
        await getConst('ORDER_STATUS_CHOICES').then((res: any) => {
          let list: any[] = res.data.map((status: any) => {
            const item: any = {}
            switch (status.field) {
              case 0:
                item.type = 'primary'
                item.id = 0
                break
              case 1:
                item.type = 'success'
                item.id = 1
                break
              case 2:
                item.type = 'info'
                item.id = 2
                break
              case 3:
                item.type = 'warning'
                item.id = 3
                break
              case 4:
                item.type = 'danger'
                item.id = 4
                break
              case 5:
                item.type = 'danger'
                item.id = 5
                break
              case 6:
                item.type = 'warning'
                item.id = 6
                break
              case 7:
                item.type = 'danger'
                item.id = 7
                break
              case 8:
                item.type = 'info'
                item.id = 8
                break
              case 9:
                item.type = 'danger'
                item.id = 9
                break
              default:
                item.type = 'info'
                break
            }
            item.text = status.translation
            return item
          })
          this.SET_ORDER_STATUS_LIST(list)
        })
      } catch (e) {}
      return this.orderStatusList
    } else {
      return this.orderStatusList
    }
  }

  @Action
  public async GetOrderSourceList () {
    if (this.orderSourceList.length === 0) {
      try {
        await getConst('ORDER_SOURCE_CHOICES').then((res: any) => {
          let list: any[] = res.data.map((status: any) => {
            const item: any = { type: status.field, text: status.translation }
            return item
          })
          this.SET_ORDER_SOURCE_LIST(list)
        })
      } catch (e) {}
      return this.orderSourceList
    } else {
      return this.orderSourceList
    }
  }

  @Action
  public async GetUpstreamStatusList () {
    if (this.upstreamStatusList.length === 0) {
      try {
        await getConst('ORDER_STATUS_CHOICES').then((res: any) => {
          let list: any[] = res.data.map((status: any) => {
            const item: any = {}
            switch (status.field) {
              case 0:
                item.type = 'primary'
                item.id = 0
                break
              case 1:
                item.type = 'success'
                item.id = 1
                break
              case 2:
                item.type = 'info'
                item.id = 2
                break
              case 3:
                item.type = 'warning'
                item.id = 3
                break
              case 4:
                item.type = 'danger'
                item.id = 4
                break
              case 5:
                item.type = 'danger'
                item.id = 5
                break
              case 6:
                item.type = 'warning'
                item.id = 6
                break
              case 7:
                item.type = 'danger'
                item.id = 7
                break
              case 8:
                item.type = 'info'
                item.id = 8
                break
              case 9:
                item.type = 'danger'
                item.id = 9
                break
              case 10:
                item.type = 'warning'
                item.id = 10
                break
              default:
                item.type = 'info'
                break
            }
            item.text = status.translation
            return item
          })
          this.SET_UPSTREAM_STATUS_LIST(list)
        })
      } catch (e) {}
      return this.upstreamStatusList
    } else {
      return this.upstreamStatusList
    }
  }

  @Action
  public async GetBankCodeList () {
    if (this.orderSourceList.length === 0) {
      try {
        await getConst('ENTERPRISE_BANK_CHOICES').then((res: any) => {
          this.SET_BANK_CODE_LIST(res.data)
        })
      } catch (e) {}
      return this.bankCodeList
    } else {
      return this.bankCodeList
    }
  }

  @Action
  public async SetCurrentCurrencyType (str: string) {
    this.SET_CURRENT_CURRENCY_TYPE(str)
  }

  @Action
  public async SetEnterprise (res: any) {
    this.SET_ENTERPRISE(res)
  }

  @Action
  public async GetEnterprise () {
    try {
      await getEnterprise().then((res: any) => {
        this.SET_ENTERPRISE(res)
        let currency: any = getCurrency()
        if (!currency) {
          this.SET_CURRENT_CURRENCY_TYPE(res.available_currency[0])
        } else {
          // this.SET_CURRENT_CURRENCY_TYPE(currency)
          let currencyIndex: any = res.available_currency.indexOf(getCurrency())
          if (currencyIndex !== -1) {
            this.SET_CURRENT_CURRENCY_TYPE(currency)
          } else {
            removeProduct()
            this.SET_CURRENT_CURRENCY_TYPE(res.available_currency[0])
          }
        }
        sessionStorage.setItem(
          'timeZoneData',
          JSON.stringify(res.available_currency_timezone)
        )
      })
    } catch (e) {}
  }

  @Action
  public ResetEnterprise () {
    const enterprise = {
      name: '',
      manage_domain: '',
      merchant_domain: '',
      checkout_counter_domain: '',
      timezone: '',
      available_currency: [],
      google_auth_switch: true,
      available_crypto_currency: [],
      sms_apk: '',
      bot_google_auth_switch: false,
      corporation: 0,
      id: 0,
      cloud_instance: '',
      corporation_name: ''
    }
    this.SET_ENTERPRISE(enterprise)
  }

  @Action
  public ToggleSideBar (withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar (withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }

  @Action
  public ToggleDevice (device: DeviceType) {
    this.TOGGLE_DEVICE(device)
  }

  @Action
  public SetLanguage (language: string) {
    this.SET_LANGUAGE(language)
  }

  @Action
  public SetSiteName (name: string) {
    this.SET_SITENAME(name)
  }

  @Action
  public SetSiteLogo (logo: string) {
    this.SET_SITELOGO(logo)
  }

  @Action
  public SetSize (size: string) {
    this.SET_SIZE(size)
  }
}

export const AppModule = getModule(App)
